import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import useDispatch from 'hooks/use-dispatch'
import loadByIdProductVariantAction from 'modules/product-variant/redux/actions/load-by-id'
import { PRODUCTS_KEY } from 'modules/product/redux/constants'
import getByUseItWithVariantIdProductSelector from 'modules/product/redux/selectors/get-by-perfect-your-look-variant-id'
import useSelector from 'hooks/use-selector'
import logUtil from 'utils/log'
import H3 from 'components/H3'
import QuickShopProductSidebarUseItWithProduct from 'containers/QuickShopProductSidebar/components/UseItWith/components/Product'
import isLoadedQuickShopProductSidebarUseItWithSelector from 'containers/QuickShopProductSidebar/components/UseItWith/selectors/is-loaded'
import QuickShopProductSidebarUseItWithButton from 'containers/QuickShopProductSidebar/components/UseItWith/Button'
import loadInfoVariantAction from 'modules/variant/redux/actions/load-info'

const TITLE = 'Use It With'

/**
 * @param props
 * @param {number} props.perfectYourLookVariantId
 * @param {number[]} props.perfectYourLookVariantList
 * @param {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarUseItWith (props) {
  const {
    perfectYourLookVariantId,
    perfectYourLookVariantList,
    analyticEventPrefix
  } = props
  const dispatch = useDispatch()
  const isLoaded = useSelector(
    isLoadedQuickShopProductSidebarUseItWithSelector(perfectYourLookVariantList)
  )

  /**
   * @type {ProductVariantCollection}
   */
  const perfectYourLookVariant = useSelector(
    getByUseItWithVariantIdProductSelector(perfectYourLookVariantId)
  )
  const hasUseItWithVariant = !!perfectYourLookVariant

  const debugProps = {
    perfectYourLookVariantId,
    perfectYourLookVariant,
    isLoaded,
    perfectYourLookVariantList
  }

  logUtil('QuickShopProductSidebarUseItWith').debug('debugProps=', debugProps)

  const load = async () => {
    await Promise.all(
      perfectYourLookVariantList.map((variantId) => {
        return (
          dispatch(
            loadByIdProductVariantAction({
              variantId,
              key: PRODUCTS_KEY.BY_PERFECT_YOUR_LOOK_VARIANT_ID
            })
          )
        )
      })
    )
  }

  React.useEffect(() => {
    load()
  }, [perfectYourLookVariantId])

  const loadVariants = async () => {
    if (!hasUseItWithVariant) {
      return
    }

    await Promise.all(
      perfectYourLookVariantList.map((variantId) => {
        return (
          dispatch(
            loadInfoVariantAction({
              variantId,
              productId: perfectYourLookVariant?.product_id,
              variantPrice: perfectYourLookVariant?.price,
              variantSku: perfectYourLookVariant?.sku
            })
          )
        )
      })
    )
  }

  React.useEffect(() => {
    loadVariants()
  }, [
    hasUseItWithVariant,
    perfectYourLookVariantId
  ])

  if (!isLoaded) {
    return <></>
  }

  if (!hasUseItWithVariant) {
    return <></>
  }

  return (
    <FlexColumn
      className='quick-shop-product-sidebar-perfect-your-look'
    >
      <H3>
        {TITLE}
      </H3>

      <QuickShopProductSidebarUseItWithProduct
        perfectYourLookVariant={perfectYourLookVariant}
        perfectYourLookVariantIds={perfectYourLookVariantList}
        analyticEventPrefix={analyticEventPrefix}
      />

      <QuickShopProductSidebarUseItWithButton
        analyticEventPrefix={analyticEventPrefix}
      />

    </FlexColumn>
  )
}
